import i18n from "@/i18n";

export default [
  { id: "enabled", name: i18n.t("integrations.fields.enabled") },
  { id: "disabled", name: i18n.t("integrations.fields.disabled") }
];
